module.exports = __webpack_public_path__ + "static/img/sterownik_systemu.73c480c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/sterownik_systemu.png
// module id = kl/k
// module chunks = 1